// extracted by mini-css-extract-plugin
export default {"inputWrapper":"parent-stats-progress_inputWrapper__bk-+S","label":"parent-stats-progress_label__ElNLk","textToolTip":"parent-stats-progress_textToolTip__5en8Y"};